import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isoWeek from 'dayjs/plugin/isoWeek';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat)
dayjs.extend(isoWeek)
dayjs.extend(utc);

export default dayjs;